<template>
	<cards-view :fanzoneTypesIds='[2]' url='fanzone-urban-action' />
</template>

<script>
	import cardsView from '../components/CardsView'
	
	export default {
		components: { cardsView }
	}
</script>
